/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListToolsetToolFiltersSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListToolsetToolFiltersSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListToolsetToolFiltersSecurity = {
  option1?: ListToolsetToolFiltersSecurityOption1 | undefined;
  option2?: ListToolsetToolFiltersSecurityOption2 | undefined;
};

export type ListToolsetToolFiltersRequest = {
  /**
   * The slug of the toolset
   */
  slug: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListToolsetToolFiltersSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListToolsetToolFiltersSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ListToolsetToolFiltersSecurityOption1$Outbound,
    ListToolsetToolFiltersSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listToolsetToolFiltersSecurityOption1ToJSON(
  listToolsetToolFiltersSecurityOption1: ListToolsetToolFiltersSecurityOption1,
): string {
  return JSON.stringify(
    ListToolsetToolFiltersSecurityOption1$outboundSchema.parse(
      listToolsetToolFiltersSecurityOption1,
    ),
  );
}

/** @internal */
export type ListToolsetToolFiltersSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListToolsetToolFiltersSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ListToolsetToolFiltersSecurityOption2$Outbound,
    ListToolsetToolFiltersSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function listToolsetToolFiltersSecurityOption2ToJSON(
  listToolsetToolFiltersSecurityOption2: ListToolsetToolFiltersSecurityOption2,
): string {
  return JSON.stringify(
    ListToolsetToolFiltersSecurityOption2$outboundSchema.parse(
      listToolsetToolFiltersSecurityOption2,
    ),
  );
}

/** @internal */
export type ListToolsetToolFiltersSecurity$Outbound = {
  Option1?: ListToolsetToolFiltersSecurityOption1$Outbound | undefined;
  Option2?: ListToolsetToolFiltersSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListToolsetToolFiltersSecurity$outboundSchema: z.ZodMiniType<
  ListToolsetToolFiltersSecurity$Outbound,
  ListToolsetToolFiltersSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListToolsetToolFiltersSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListToolsetToolFiltersSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listToolsetToolFiltersSecurityToJSON(
  listToolsetToolFiltersSecurity: ListToolsetToolFiltersSecurity,
): string {
  return JSON.stringify(
    ListToolsetToolFiltersSecurity$outboundSchema.parse(
      listToolsetToolFiltersSecurity,
    ),
  );
}

/** @internal */
export type ListToolsetToolFiltersRequest$Outbound = {
  slug: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListToolsetToolFiltersRequest$outboundSchema: z.ZodMiniType<
  ListToolsetToolFiltersRequest$Outbound,
  ListToolsetToolFiltersRequest
> = z.pipe(
  z.object({
    slug: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listToolsetToolFiltersRequestToJSON(
  listToolsetToolFiltersRequest: ListToolsetToolFiltersRequest,
): string {
  return JSON.stringify(
    ListToolsetToolFiltersRequest$outboundSchema.parse(
      listToolsetToolFiltersRequest,
    ),
  );
}
